import { Model } from '@/models/Model';
import client from '@/support/Client';
export class UserSubject extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'UserSubject';
        this.$endpoint = '/users/{id}/relationships/subjects';
        this.$fillable = ['status', 'environment', 'subjects', 'files', 'progress'];
    }
    user(user) {
        if (typeof user !== 'string') {
            user = user.id || '';
        }
        this.$endpoint = `/users/${user}/relationships/subjects`;
        return this;
    }
    setIdAttribute(id) {
        this.$endpoint = `/users/${this.user}/relationships/subjects`;
        return id;
    }
    setSubjectId(id) {
        this.id = id;
        return this;
    }
    // Sorry Bryse :_(
    setDeleteEndpoint(user, subjectId) {
        if (typeof user !== 'string') {
            user = user.id || '';
        }
        this.$endpoint = `/users/${user}/relationships/subjects/${subjectId}`;
        return this;
    }
    setMassEndpoint(id) {
        this.$endpoint = `users/${id}/relationships/subjects/mass`;
        return this;
    }
    updateMass(id, payload) {
        this.$endpoint = `users/${id}/relationships/subjects/mass`;
        const url = this.$endpoint;
        return this.request('patch', url, this.getPayload(payload));
    }
    resolvePrimaryKey() {
        return '';
    }
    uploadFile(payload, template) {
        const formData = new FormData();
        payload.forEach((fileObject, index) => {
            formData.append(`files[${index}][file]`, fileObject.file);
            formData.append(`files[${index}][collection]`, fileObject.collection);
        });
        if (template) {
            formData.append('template', template);
        }
        return client('post', `${this.$endpoint}/${this.id}`, formData);
    }
    bulkUpdate(payload) {
        return client('post', `/student-subjects`, payload);
    }
    bulkUpdateDescription(payload) {
        return client('post', `/student-subjects/bulk`, payload);
    }
    bulkUpdateSubjectToStudents(payload) {
        return client('patch', `/student-subjects/bulk-add-subjects-to-students`, payload);
    }
    bulkUpdateClearStudentStatuses(payload) {
        return client('patch', `/student-subjects/bulk-clear-student-statuses`, payload);
    }
    putSubject(payload) {
        return client('put', this.$endpoint, payload);
    }
}
export var UserSubjectStatusEnum;
(function (UserSubjectStatusEnum) {
    UserSubjectStatusEnum["HIGHLIGHTED"] = "highlighted";
    UserSubjectStatusEnum["BUSY"] = "busy";
    UserSubjectStatusEnum["CLOSED"] = "closed";
    UserSubjectStatusEnum["OLD"] = "old";
    UserSubjectStatusEnum["INACTIVE"] = "inactive";
    UserSubjectStatusEnum["FINISHED"] = "finished";
    UserSubjectStatusEnum["FUTURE"] = "future";
    UserSubjectStatusEnum["LESSON_DONE"] = "lesson_done";
})(UserSubjectStatusEnum || (UserSubjectStatusEnum = {}));
